/**
 *
 * App
 *
 * This component is the skeleton around the actual pages, and should only
 * contain code that should be seen on all pages. (e.g. navigation bar)
 */

import * as React from 'react';
import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { BrowserRouter, Route, Switch } from 'react-router-dom';

import { GlobalStyle } from 'styles/global-styles';

import { ConfigProvider } from 'antd';
import { Branding } from '@shared/enums/Branding';
import { OnboardingPage } from './containers/OnboardingPage/Loadable';
import { DashboardRoute } from './containers/DashboardRoute/Loadable';
import { NotFoundPage } from './components/NotFoundPage/Loadable';
import { SessionExpired } from './containers/SessionExpiredPage/Loadable';
import './styles.less';

import UserContext, { UserContextProvider } from './contexts/user';
import { defaultValidateMessages } from '../utils/client.utils';

function RenderRoutes() {
    const { user, error } = React.useContext(UserContext);
    useEffect(() => {
        if (user?.branding === Branding.RIPPLE) {
            document.body.classList.add('ripple');
        }
    }, [user]);
    const app = error ? (
        <SessionExpired />
    ) : (
        <Switch>
            <Route exact path="/" component={OnboardingPage} />
            <Route path="/dashboard" component={DashboardRoute} />
            <Route component={NotFoundPage} />
        </Switch>
    );

    return (
        <ConfigProvider
            form={{
                validateMessages: defaultValidateMessages,
            }}>
            {app}
        </ConfigProvider>
    );
}

export function App() {
    return (
        <BrowserRouter>
            <UserContextProvider>
                <Helmet titleTemplate="%s" defaultTitle="Onboarding Portal">
                    <meta name="description" content="Onboarding Portal" />
                </Helmet>
                <RenderRoutes />
                <GlobalStyle />
            </UserContextProvider>
        </BrowserRouter>
    );
}
